import React, {useState} from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import withWidth from '@material-ui/core/withWidth';
import TextField from '@material-ui/core/TextField';

import {withStyles} from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';

import {lighten} from '@material-ui/core/styles';

const MobileStyle= theme => {
  console.log(theme.palette)
  return ({
    TextField:{
      '& label.Mui-focused': {
        color: prop => {
          return prop.inOut?blue['700']:orange['900']
        },
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: prop => prop.inOut?blue['700']:orange['700'],
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: prop => prop.inOut?blue['700']:orange['700'],
        },
        // '&:hover fieldset': {
        //   borderColor: 'yellow',
        // },
        '&.Mui-focused fieldset': {
          borderColor: prop => prop.inOut?blue['700']:orange['700'],
        },
      },
    },
    Grid:{
      padding:10,
      border:`2px solid ${blue['100']}`,
      borderRadius:'1rem'
    }
  });
};

const MobileMode = (props) => {
  const {width, classes} = props;
  const [ceoficient, setDarken] = useState(10);

  return (
    <Grid container className={classes.Grid}>
      <h2 style={{color:lighten(blue['500'], ceoficient/100)}}>show mobile Stuff here</h2>
      {width==='xs'&&
        <Grid item>
          <TextField 
            className={classes.TextField}
            type='number'
            value={ceoficient}
            onChange={evt => setDarken(evt.target.value)}
            variant='outlined'
            label='set hue'
          />
        </Grid>
      }
         
    </Grid>
  );
};
const MobileModeStyled = withStyles(MobileStyle)(prop=><MobileMode {...prop} />);

const mapStateToProps = (state) => ({
   
});

const mapDispatchToProps = {
   
};
// const MobileModeStyledRedux=connect(mapStateToProps, mapDispatchToProps)(MobileModeStyled)


export default withWidth()(connect(mapStateToProps, mapDispatchToProps)(MobileModeStyled));
